/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

/** Utilities */
import { mapDropdownOptions } from '../../../../components/finalForms/libs/mapDropdownOptions';

/** Common Components */
import Buttons from '../../../../components/ui/button/Buttons';
import FormCreator from '../../../../components/finalForms/FormCreator';

/** Common Services & Data Files */
import { AppIcons } from '../../../../data/appIcons';
import ToastService from '../../../../services/toastService/ToastService';

/** Configuration Files */
import { projectStatusTestFormData } from './config/ProjectStatusTest.data';

/** RTK Query */
import {
    useAddProjectStatusMutation,
    useUpdateProjectStatusByIDMutation
} from '../../../../app/services/projectStatusAPI';
import { useLazyGetAllStatusCategoriesQuery } from '../../../../app/services/taskStatusAPI';

const AddProjectStatusTest = (props) => {
    const ref = useRef();
    /* State*/
    const [formData, setFormData] = useState(projectStatusTestFormData);
    const ProjectId = props.projectId;
    // API'S Call
    const [addProjectStatus, {
        isSuccess: isProjectStatusAdded,
        isLoading: isProjectStatusAdding,
        data: addProjectStatusData
    },] = useAddProjectStatusMutation();

    const [getAllStatusCategoriesList, {
        isFetching: isGetAllStatusCategoriesListFetching,
        isSuccess: isGetAllStatusCategoriesListSuccess,
        data: getAllStatusCategoriesListData
    },] = useLazyGetAllStatusCategoriesQuery();

    const [updateProjectStatus, {
        isLoading: updateProjectStatusLoading,
        isSuccess: isSuccessUpdateProjectStatus,
        data: updateProjectStatusData
    }] = useUpdateProjectStatusByIDMutation();

    //** useEffect's */
    useEffect(() => {
        getAllStatusCategoriesList();
    }, [])

    useEffect(() => {
        if (!isGetAllStatusCategoriesListFetching && isGetAllStatusCategoriesListSuccess && getAllStatusCategoriesListData) {
            mapDropdownOptions(
                projectStatusTestFormData,
                'projectStatus',
                'statusCategoryId',
                getAllStatusCategoriesListData,
                'statusCategoryId',
                'statusCategoryName'
            );
        }
    }, [isGetAllStatusCategoriesListFetching, isGetAllStatusCategoriesListSuccess, getAllStatusCategoriesListData])

    useEffect(() => {
        if (props.selectedCategory) {
            let Data = { ...formData };
            Data.initialState = {
                ...formData.initialState,
                statusName: props.selectedCategory.statusName,
                statusCategoryId: props.selectedCategory.statusCategoryId
            }
            setFormData(Data);
        };
    }, [props.selectedCategory]);

    useEffect(() => {
        if (isProjectStatusAdded && addProjectStatusData) {
            if (addProjectStatusData.errorMessage.includes("exists")) {
                ToastService.warning(addProjectStatusData.errorMessage);
                return;
            }
            else {
                ToastService.success(addProjectStatusData.errorMessage);
                backToList();
                props.getProjectStatusList();
            }
        }
    }, [isProjectStatusAdded, addProjectStatusData]);

    useEffect(() => {
        if (isSuccessUpdateProjectStatus && updateProjectStatusData) {
            if (updateProjectStatusData.errorMessage.includes("exists")) {
                ToastService.warning(updateProjectStatusData.errorMessage);
                return;
            } else {
                ToastService.success(updateProjectStatusData.errorMessage);
                backToList();
                props.getProjectStatusList();
            }
        }
    }, [isSuccessUpdateProjectStatus, updateProjectStatusData])

    //** Funcation's */
    const handleSubmit = () => {
        const formData = ref.current.getFormData();
        if (formData) {
            if (!props.selectedCategory) {
                const requestData = {
                    ...formData,
                    statusName: formData.statusName,
                    isActive: formData.isActive || true,
                    isComplete: formData.isComplete || true,
                    isBacklog: formData.isBacklog || false,
                    isDefault: formData.isDefault || false,
                    projectId: ProjectId,
                    statusCategoryId: formData.statusCategoryId && typeof formData.statusCategoryId === 'object'
                        ? formData.statusCategoryId.value
                        : formData.statusCategoryId
                }
                addProjectStatus(requestData);
            }
            else if (props.selectedCategory) {
                const DataUpdate = {
                    ...formData,
                    statusName: formData.statusName,
                    isActive: formData.isActive || true,
                    isComplete: formData.isComplete || true,
                    isBacklog: formData.isBacklog || false,
                    isDefault: formData.isDefault || false,
                    projectId: ProjectId,
                    projectStatusConfigurationId: props.selectedCategory.projectStatusConfigurationId,
                    statusCategoryId: formData.statusCategoryId && typeof formData.statusCategoryId === 'object'
                        ? formData.statusCategoryId.value
                        : formData.statusCategoryId
                }
                updateProjectStatus(DataUpdate)
            }
        }
    }

    const formReset = () => {
        const projectForm = { ...projectStatusTestFormData };
        projectForm.initialState = { ...projectStatusTestFormData.initialState };
        setFormData(projectForm);
    }

    const backToList = () => {
        props.onSidebarClose();
        formReset();
    };

    return (
        <div className="">
            <form>
                <div className="row">
                    <FormCreator
                        config={formData}
                        ref={ref}
                        {...formData} />
                </div>
            </form>
            <div className="row">
                <div className="col-12">
                    <div className="form-btn d-flex justify-content-end">
                        <Buttons
                            buttonTypeClassName="dark-btn"
                            onClick={backToList}
                            buttonText="Cancel"
                        />
                        <Buttons
                            buttonTypeClassName="theme-btn ml-4"
                            onClick={handleSubmit}
                            buttonText={props.selectedCategory ? "Update" : "Add"}
                            isLoading={isProjectStatusAdding || updateProjectStatusLoading}
                            imagePath={AppIcons.AddIcon}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

AddProjectStatusTest.propTypes = {
    onSidebarClose: PropTypes.func.isRequired,
};

export default AddProjectStatusTest;